import { render, staticRenderFns } from "./DanhSachSanPham.vue?vue&type=template&id=643e0d48&"
import script from "./DanhSachSanPham.vue?vue&type=script&lang=js&"
export * from "./DanhSachSanPham.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports